<template>
  <div class="content-contrainer">
    <div class="content-banner" :class="__lang"></div>
    <div class="content-menu-list">
      <div class="main-box">
        <router-link v-for="(item, index) in childrenMenu.child" :key="index" :to="item.link" class="content-menu-list-item" active-class="active">{{item.name}}</router-link>
      </div>
    </div>
    <html404 v-if="content===null"></html404>
    <div v-else>
      <block :title="lang[__lang][routeName]">
        <div class="main-box" style="margin-top: 50px;">
          <table class="join-table" style="width:100%;">
            <thead>
              <tr>
                <th>部门</th>
                <th>职位</th>
                <th>工作经验</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in content">
                <tr v-for="(item2, index2) in item.child" :key="index+'_'+index2">
                  <td v-if="index2===0" :rowspan="item.child.length">{{item.name}}</td>
                  <td>{{item2.name}}</td>
                  <td>{{item2.workExp}}</td>
                  <td class="text-center">
                    <router-link :to="'join/detail/'+item.id+'/'+item2.id">
                      <el-button class="icon-plus" type="text">查看详情 <i class="el-icon-plus"></i></el-button>
                    </router-link>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </block>
    </div>
  </div>
</template>

<script>
import { navbar, join as data } from "../../data.js";
import lang from "../../lang.js";
import block from "../../components/block.vue";
import html404 from "../../components/404.vue";
export default {
  name: "join",
  components:{
    block,
    html404
  },
  data() {
    return {
      lang,
      data,
      active:0
    };
  },
  computed:{
    menus(){
      return navbar({
        lang:this.$route.params.lang || 'zh-CN'
      })
    },
    childrenMenu(){
      return this.menus.find(v=>v.id=="join");
    },
    __lang(){return this.$route.params.lang},
    content(){
      const lang = this.__lang;
      return data[lang].data||null;
    },
    routeName(){
      return this.$route.name;
    }
  },
  methods:{
    checkLabor(index) {
      this.active = index;
    }
  },
  created(){
    console.log(this.content);
  }
};
</script>

<style lang="less" scoped>
.content-contrainer {
  padding-bottom: 60px;
}
.content-banner {
  margin-top: 70px;
  width: 100%;
  height: 340px;
  background: url(../../assets/img/banner_jiaru.jpg) center center no-repeat;
  &.en {
    background: url(../../assets/img/banner_jiaru_en.png) center center no-repeat;
  }
}
.content-menu-list {
  border-bottom: 1px solid #999;
  overflow: hidden;
  .content-menu-list-item {
    text-decoration: none;
    color: #222;
    float: left;
    line-height: 60px;
    font-size: 16px;
    padding: 0 20px;
    &.active{
      color: #d22c1d;
    }
    &.active:after {
      display: block;
      content: " ";
      width: 60%;
      height: 4px;
      background-color: #d22c1d;
      margin: auto;
    }
  }
}
.filed-desc {
  padding: 40px 0;
  line-height: 30px;
  font-size: 18px;
}
.labor-checkbox {
  margin-bottom: 40px;
  .labor-checkbox-btn {
    display:block;
    width: 100%;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding: 0;
    background-color: #eee;
    color: #222;
    text-decoration: none;
    border-radius: 0;
    font-size: 18px;
    .icon {
      width: 36px;
      display: inline-block;
      height: 100%;
      vertical-align:
      middle;margin-right: 10px;
    }
    .icon1 {
      display: none;
    }
    .icon2{
      display: inline-block;
    }
    &.active{
      color: #fff;
      background-color: #d22c1d;
      .icon2 {
        display: none;
      }
      .icon1{
        display: inline-block;
      }
    }
  }
}
.st-desc {
  position: relative;
  .text1-box {
    position: absolute;
    top: 0;
    left: 130px;
    right: 143px;
    margin: 100px auto;
    height: 130px;
    .icon{
      margin-top: 20px;
      margin-left: 100px;
      margin-right: 50px;
      float: left;
    }
    p{
      color: #fff;
      margin-top: 20px;
      margin-right: 50px;
      line-height: 1.8;
    }
  }
}
.databox {
  margin-top: 20px;
}
.datacontent {
  img{
    width: 100%;
  }
}
.join-table {
  border-collapse: collapse;
  border-bottom: 5px solid #14224f;
  th,td{
    line-height: 58px;
    border: 1px solid #14224f;
    padding: 0 30px;
    margin: 0;
  }
  th{
    background-color: #14224f;
    color:#fff;
  }
}
.icon-plus {
  color: #222;
  &:hover {
    color: #d22c1d;
  }
}
</style>
